import * as XLSX from 'xlsx';

export const generateExcelTemplate = () => {
  const data = [
    [
      "בית עלמין",
      "נרכש בחיים",
      "נגבה תשלום",
      "מספר זהות",
      "סוג זהוי",
      "רשיון קבורה",
      "דרכון",
      "שם משפחה",
      "שם פרטי",
      "תאריך לידה",
      "תאריך פטירה",
      "פטירה בחול",
      "סוג זיהוי הורה",
      "מספר זהות הורה",
      "דרכון הורה",
      "שם משפחה הורה",
      "שם פרטי הורה",
      "תאריך קבורה",
      "יום/לילה",
      "שעת קבורה",
      "קוד גוש",
      "קוד חלקה",
      "שורה",
      "קומה",
      "מס קומה",
      "מס תת קומה",
    ],
    [
      "הר הזיתים",
      "כן",
      "לא",
      "123456789",
      "תז",
      "001234",
      "A12345678901234",
      "לוי",
      "משה",
      "19800101",
      "20250101",
      "לא",
      "תז",
      "123456780",
      "B12345678901234",
      "כהן",
      "רחל",
      "20250115",
      "כ",
      "1230",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
    ],
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Template");

  XLSX.writeFile(workbook, "ExcelTemplate.xlsx");
};

// generateExcelTemplate();
